import type { ArticlePreview } from '$lib/utils/definitions';

export const articles: ArticlePreview[] = [
  {
    title: 'Comment savoir si je suis éligible au Bail Réel Solidaire (BRS) ?',
    description: `Découvrez si vous êtes éligible au Bail Réel Solidaire (BRS). Critères, plafonds de revenus, exemples concrets et simulateur officiel pour tout savoir.`,
    firstPublishedAt: '2025-07-01T11:00:00.527438+01:00',
    slug: 'comment-savoir-si-je-suis-eligible-au-bail-reel-solidaire-brs',
  },
  {
    title: '5 idées reçues sur le bail réel solidaire (brs)',
    description: `Le bail réel solidaire (BRS) souffre de quelques fausses idées: "je ne pourrai jamais revendre", "je ne suis pas propriétaire"… Découvrez la vérité sur le bail réel solidaire (BRS) via BoRiS, plateforme officielle du gouvernement dédiée au bail réel solidaire.`,
    firstPublishedAt: '2025-06-25T11:46:39.527438+01:00',
    slug: '5-idees-recues-sur-le-bail-reel-solidaire-brs',
  },
  {
    title: 'Le Bail Réel Solidaire (BRS), c’est quoi exactement?',
    description:
      "Découvrez le Bail Réel Solidaire (BRS), un dispositif innovant permettant d'acheter son logement 30 à 50% moins cher. Conditions d'éligibilité au BRS, avantages, inconvénients, où trouver un logement en BRS... on vous explique tout sur le bail réel solidaire",
    firstPublishedAt: '2025-06-12T11:46:39.527438+01:00',
    slug: 'le-bail-reel-solidaire-brs-cest-quoi-exactement',
  },
  {
    title: 'Puis-je acheter un logement en BRS si je suis déjà propriétaire?',
    description:
      'Si vous êtes déjà propriétaire, êtes-vous éligible au Bail Réel Solidaire ? Nous vous proposons de répondre à cette question dans cet article.',
    firstPublishedAt: '2025-01-08T11:46:39.527438+01:00',
    slug: 'puis-je-acheter-un-logement-en-brs-si-je-suis-deja-proprietaire',
  },
  {
    title:
      'Acheter son logement sans se ruiner : 3 solutions à connaître absolument',
    description:
      'Accéder à la propriété peut sembler compliqué, mais des solutions comme le Bail Réel Solidaire, le Prêt à Taux Zéro et le PSLA permettent d’acheter un logement dans des conditions avantageuses. Découvrez comment ces dispositifs peuvent vous aider à concrétiser votre projet.',
    firstPublishedAt: '2025-01-07T15:15:15.899904+01:00',
    slug: 'acheter-son-logement-sans-se-ruiner-3-solutions-a-connaitre-absolument',
  },
  {
    title: 'Un exemple pour vous projeter dans votre achat en BRS',
    description:
      'Imaginons que vous avez repéré un appartement NEUF de 70 m² en BRS à 210.000 euros à Lyon. Voici un […]',
    firstPublishedAt: '2025-01-07T11:57:13.129273+01:00',
    slug: 'un-exemple-pour-vous-projeter-dans-votre-achat-en-brs',
  },
];
